import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { CONTACT } from "../lib/menuData";

const LINKS = [
  { label: "Über uns", href: "#herkunft" },
  { label: "Spezialitäten", href: "#spezialitaeten" },
  { label: "Speisekarte", href: "#speisekarte" },
  { label: "Location", href: "#location" },
  { label: "Kontakt", href: "#kontakt" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-teal-dark/85 backdrop-blur-xl border-b border-gold/15 py-3" : "py-5"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 md:px-10 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3">
          <img src="/logo.png" alt="Ceylon Royal Kitchen" className="h-11 w-auto rounded-md" />
          <span className="font-serif text-lg md:text-xl text-cream leading-none tracking-wide hidden sm:block">
            Ceylon Royal <span className="text-gold">Kitchen</span>
          </span>
        </a>

        <div className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-${l.href.slice(1)}`}
              className="link-underline text-sm text-cream/80 hover:text-cream transition-colors">
              {l.label}
            </a>
          ))}
          <a href={CONTACT.phoneHref} data-testid="nav-order-btn"
            className="hidden lg:flex items-center gap-2 text-sm text-cream/80 hover:text-cream transition-colors">
            <Phone size={15} className="text-gold" /> {CONTACT.phone}
          </a>
          <a href="#speisekarte" data-testid="nav-order-cta"
            className="text-sm font-medium bg-gold text-teal-dark px-5 py-2.5 rounded-full hover:bg-gold-light transition-colors">
            Jetzt bestellen
          </a>
        </div>

        <button data-testid="mobile-menu-toggle" className="md:hidden text-cream" onClick={() => setOpen(!open)}>
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-teal-dark/95 backdrop-blur-xl border-t border-gold/15 mt-3">
          <div className="px-6 py-6 flex flex-col gap-5">
            {LINKS.map((l) => (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)}
                className="text-cream/85 text-base">{l.label}</a>
            ))}
            <a href="#speisekarte" onClick={() => setOpen(false)}
              className="text-center bg-gold text-teal-dark px-5 py-3 rounded-full font-medium">
              Jetzt bestellen
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
